import { RecordContextProvider } from 'react-admin';
import { CardTable } from 'shared/mui/Card/CardTableNew/CardTable';
import { TableRowWrapper } from 'shared/mui/Table/TableRowWrapperNew/TableRowWrapper';
import {
  DateField,
  EmbeddedFunctionField,
  FunctionField,
  TextField,
  UserProfileField,
} from 'shared/react-admin/Fields';
import { BankOperation } from 'types/embedded/bankOperation';
import { Currency } from 'types/embedded/currency';
import { User } from 'types/embedded/user';
import { formatCurrency } from 'utils';

export const BankOperationsShowTabsInfo: React.FC = () => {
  return (
    <CardTable tableBodyProps={{ sx: { '& td': { width: '208px' } } }}>
      <TableRowWrapper label="Провайдер">
        <EmbeddedFunctionField sourceField="provider.name" />
      </TableRowWrapper>
      <TableRowWrapper label="Направление">
        <EmbeddedFunctionField sourceField="direction.description" />
      </TableRowWrapper>
      <TableRowWrapper label="Тип банковской операции">
        <EmbeddedFunctionField sourceField="type.description" sx={{ wordBreak: 'keep-all' }} />
      </TableRowWrapper>
      <TableRowWrapper label="Счет мерчанта">
        <EmbeddedFunctionField sourceField="merchantAccount.name" />
      </TableRowWrapper>
      <TableRowWrapper label="Сумма">
        <FunctionField
          render={({ amountPenny }: BankOperation) => formatCurrency(Number(amountPenny))}
          sx={{ fontWeight: 500 }}
        />
      </TableRowWrapper>
      <TableRowWrapper label="Валюта">
        <EmbeddedFunctionField
          render={(value: Currency) => `${value?.alphaCode}, ${value?.name}`}
          sourceField="currency"
          sx={{ fontWeight: 500 }}
        />
      </TableRowWrapper>
      <TableRowWrapper label="Дата в ПС">
        <DateField source="dateOfOperation" />
      </TableRowWrapper>
      <TableRowWrapper label="Комментарий">
        <TextField emptyText="—" source="description" sx={{ wordBreak: 'break-word' }} />
      </TableRowWrapper>
      <TableRowWrapper label="Согласующий">
        <EmbeddedFunctionField
          render={(value: User) => (
            <RecordContextProvider value={value}>
              <FunctionField render={() => <UserProfileField />} />
            </RecordContextProvider>
          )}
          sourceField="approver"
        />
      </TableRowWrapper>
    </CardTable>
  );
};
